import { createAsyncThunk } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';

import map from 'lodash/map';

export const createAsyncThunks = (config) => {
	const thunks = [];
	map(config, (value, key) => {
		thunks.push({ [key]: createAsyncThunk(key, value) });
	});

	return thunks.reduce((a, b) => ({ ...a, ...b }));
};

export const useThunks = (...thunks) => {
	const dispatch = useDispatch();
	return useMemo(
		() =>
			thunks.map(
				(thunk) =>
					(...args) =>
						dispatch(thunk(...args))
			),
		/* eslint-disable-next-line react-hooks/exhaustive-deps */
		[dispatch, ...thunks]
	);
};

export const useThunk = (thunk) => {
	return useThunks(thunk)[0];
};
